(function() {
  const stickyCart = document.querySelector('.mobile-sticky-add-to-cart');
  if (!stickyCart) return;

  const qtyInput = stickyCart.querySelector('.qty-input');
  const qtyMinus = stickyCart.querySelector('.qty-minus');
  const qtyPlus = stickyCart.querySelector('.qty-plus');
  const buttons = stickyCart.querySelectorAll('.mobile-sticky-add-to-cart__btn');

  if (qtyMinus) {
    qtyMinus.addEventListener('click', () => {
      const current = parseInt(qtyInput.value);
      if (current > 1) qtyInput.value = current - 1;
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
    });
  }

  // Button actions
buttons.forEach(button => {

  button.addEventListener('click', function(){

    const action = this.dataset.action;

    const quantity =
      qtyInput
      ? parseInt(qtyInput.value)
      : 1;

    if(action === 'add-to-cart'){

      // sync quantity with original product quantity
      const mainQty =
        document.querySelector(
          'input[name="quantity"]'
        );

      if(mainQty){
        mainQty.value = quantity;

        mainQty.dispatchEvent(
          new Event(
            'change',
            { bubbles:true }
          )
        );
      }

      // click original Dawn Add to Cart
      const originalButton =
        document.querySelector(
          '.product-form__submit'
        );

      if(originalButton){
        originalButton.click();
      }

    }

    else if(action === 'buy-now'){

      const variantId =
      this.dataset.variantId;

      buyNow(
        variantId,
        quantity
      );

    }

  });

});

// ===== Sticky show/hide on scroll =====
// ===== Sticky show/hide on scroll =====
const footer = document.querySelector('footer');

function toggleStickyVisibility() {

  // desktop always hide
  if (window.innerWidth > 749) {
    stickyCart.style.display = 'none';
    return;
  }

  if (!footer) return;

  const scrollY = window.scrollY;

  // 100px before footer hide
  const footerTop = footer.offsetTop - 100;

  if (
    scrollY > 800 &&
    (scrollY + window.innerHeight) < footerTop
  ) {
    stickyCart.style.display = 'block';
  } else {
    stickyCart.style.display = 'none';
  }

}

window.addEventListener(
  'scroll',
  toggleStickyVisibility
);

window.addEventListener(
  'resize',
  toggleStickyVisibility
);

toggleStickyVisibility();

  // Buy Now function
  function buyNow(variantId, quantity) {
    // Redirect to checkout with product
    window.location.href = `/cart/${variantId}:${quantity}`;
  }

  // Notification function
  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: ${type === 'success' ? '#4CAF50' : '#f44336'};
      color: white;
      padding: 12px 24px;
      border-radius: 6px;
      z-index: 1000;
      animation: slideDown 0.3s ease;
    `;
    
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  }

  // Update cart count (optional)
  function updateCartCount() {
    // Update your cart icon/count here
  }
})();